import React, { useState } from "react";
import TeamCardModal from "./TeamCardModal";

interface TeamCardProps {
  fullName: string;
  role: string;
  investsIn: string;
  bio: string;
  firmWebsite: string;
  thesis: string;
  averageCheckSize: string;
  valueProp: string;
  investorDirectoryUrl: string;
  numberOfInvestments: string;
  imageSrc: string;
}

const TeamCard: React.FC<TeamCardProps> = (props) => {
  const { fullName, role, investsIn, averageCheckSize, imageSrc } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div
        className="TeamCard w-full max-w-[276px] flex flex-col gap-4 cursor-pointer overflow-hidden"
        onClick={openModal}
      >
        {/* Image Section (strictly square, no border/padding) */}
        <div className="relative w-full aspect-square bg-gray-100 overflow-hidden">
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={fullName}
              className="w-full h-full object-cover object-center"
            />
          ) : (
            <div className="w-full h-full bg-gray-200" />
          )}
        </div>

        {/* Name and Role */}
        <div className="flex flex-col gap-2">
          <div className="text-[#122427] text-xl font-semibold leading-[30px] font-['Manrope']">
            {fullName}
          </div>
          <div className="text-[#717c79] text-sm font-medium leading-normal font-['Manrope']">
            {role}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#e3e3de]" />

        {/* Invests In */}
        <div className="flex flex-col gap-1">
          <div className="text-[#717c79] text-sm font-medium font-['Manrope']">
            Invests in
          </div>
          <div className="text-[#122427] text-sm font-medium leading-normal font-['Manrope']">
            {investsIn}
          </div>
        </div>

        {/* Average Check Size */}
        <div className="flex flex-col gap-1">
          <div className="text-[#717c79] text-sm font-medium font-['Manrope']">
            Average check size
          </div>
          <div className="text-[#122427] text-sm font-medium leading-normal font-['Manrope']">
            {averageCheckSize}
          </div>
        </div>
      </div>

      {isModalOpen && <TeamCardModal {...props} onClose={closeModal} />}
    </>
  );
};

export default TeamCard;
